<template>
  <div class="wrapper">
    <img v-if="!!url" :src="url" :alt="`slider-${option}`" />

    <p>
      {{ optionConfig.label[language] }}
    </p>

    <label :for="option">
      {{ url ? 'Change' : 'Choose' }}
    </label>

    <input
      :disabled="loading"
      type="file"
      :id="option"
      accept="image/*"
      @change="handleFileChange"
    />

    <span v-if="loading">Loading...</span>
  </div>
</template>

<script>
import { uploadFile } from '@/services/api'

import { alternativesRenderConfig } from '@/utils/alternativeOptions'

const { default: translations, ...translationKeys } = {}

export default {
  name: 'LeftRightImage',

  components: {},

  props: {
    updateAlternative: {
      required: true,
      type: Function,
    },

    option: {
      required: true,
      type: String,
    },

    questions_groups_index: {
      required: true,
      type: Number,
    },

    question_index: {
      required: true,
      type: Number,
    },

    alternative: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      translations,
      ...translationKeys,
      alternativesRenderConfig,
      loading: false,
    }
  },

  computed: {
    optionConfig() {
      return this.alternativesRenderConfig[this.option]
    },

    url() {
      return this.alternative[this.option] || null
    },
  },

  methods: {
    async handleFileChange({ target }) {
      const [file] = target.files

      if (!file.type.startsWith('image')) return

      this.loading = true

      const { url } = await uploadFile(file)

      this.loading = false

      this.updateAlternative({ [this.option]: url })
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  @include flexAlignCenter;
  gap: 16px;

  p {
    font-weight: 600;
  }

  input[type='file'] {
    display: none;
  }

  label {
    cursor: pointer;
    padding: 4px 12px;
    background: $blue;
    color: #fff;
    border-radius: 5px;
    transition: background-color 0.25s ease;
  }

  img {
    width: 56px;
    height: 56px;
    object-fit: cover;
    border-radius: 4px;
  }
}
</style>
